var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAliveCorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203.41 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #174e8c;\n            }\n\n            .cls-2 {\n                fill: #96afdb;\n            }\n\n            .cls-3 {\n                fill: #6388c5;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,200H34.1c2.06-5.86,4.77-13.22,8.08-22,1.15-3.06,2.38-6.27,3.65-9.55H12.14Q5.54,185.13,0,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.24,154.62c2.83-7.39,20-50.27,23.2-58s6.43-15.4,9.66-22.87,6.33-14.6,9.37-21.32,5.78-12.74,8.24-18h0l13.14-31A29.17,29.17,0,0,0,101.71,0q-9,.3-15.06,4.38c-4.36,3-8.23,8.19-11.65,15.77Q64.77,42.89,54.4,66.74t-20,47q-9.66,23.17-18.45,45.18c-1.29,3.22-2.54,6.37-3.78,9.49H45.83q2.58-6.68,5.42-13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.27,168.43H157.58c1.27,3.28,2.5,6.49,3.65,9.55,3.32,8.8,6,16.16,8.09,22h34.09Q197.88,185.14,191.27,168.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.5,158.94q-8.79-22-18.46-45.18t-20-47q-10.37-23.86-20.59-46.59c-3.43-7.58-7.3-12.82-11.65-15.77-.61-.4-1.28-.72-1.92-1.07L101.71,34.36q3.69,8,8.23,18t9.37,21.32q4.84,11.2,9.66,22.87c3.23,7.76,20.37,50.64,23.21,58h0q2.84,7.14,5.42,13.81h33.69C190,165.31,188.79,162.16,187.5,158.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAliveCorLogo);
export default __webpack_public_path__ + "static/media/aliveCor_logo.c7a04e94cf1fd7ca56f9e9622d6ed55e.svg";
export { ForwardRef as ReactComponent };